import { motion } from "framer-motion";

/**
 * Reveals text one line at a time by animating masked children upward.
 * Pass either `text` (splits by \\n) or `lines` (array of strings/nodes).
 */
export default function LineReveal({
  text,
  lines,
  className = "",
  stagger = 0.09,
  delay = 0,
  duration = 0.9,
  as = "div",
  initialY = "110%",
  ease = [0.7, 0, 0.2, 1],
}) {
  const arr = lines || (text ? String(text).split("\n") : []);
  const Tag = motion[as] || motion.div;

  return (
    <Tag className={className} aria-label={typeof text === "string" ? text : undefined}>
      {arr.map((ln, i) => (
        <span key={i} className="hero-line" aria-hidden={typeof text === "string"}>
          <motion.span
            className="hero-line-inner"
            initial={{ y: initialY }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              ease,
              delay: delay + i * stagger,
            }}
          >
            {ln}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
